var _circle, _path, _circle2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 5.5,
    r: 2.8,
    fill: "url(#g1_clients_h)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5C2.5 12.5 4.5 10.5 7 10.5C9.5 10.5 11.5 12.5 11.5 15.5H2.5Z",
    fill: "url(#g2_clients_h)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 5,
    r: 2.2,
    fill: "#BDCEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.5C9.5 13 11 11 13 11C15 11 16.5 13 16.5 15.5H9.5Z",
    fill: "#BDCEEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1_clients_h",
    x1: 7,
    y1: 2.7,
    x2: 7,
    y2: 8.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2_clients_h",
    x1: 7,
    y1: 10.5,
    x2: 7,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsHover);
export default __webpack_public_path__ + "static/media/clients-hover.f094a4f99fdfc9ce4cca6555b14b7fd7.svg";
export { ForwardRef as ReactComponent };